/* eslint-disable */
// vendor
import React from 'react';
import DOMPurify from 'dompurify';
import {
  withTranslation,
  WithTranslation,
  useTranslation as i18useTranslation,
} from 'react-i18next';

interface FormattedMessageProps extends WithTranslation {
  id: string;
  objName?: Record<string, any>;
  className?: string;
  onClick?: () => void;
  props?: any;
}

const getTranslation = (
  id: string,
  t: (key: string, options?: Record<string, any>) => string,
  i18n: any,
  objName: Record<string, unknown>
) => {
  const nameSpace = { ns: 'translations' };
  return i18n?.exists(id) ? t(id, { ...objName }) : t(id, { ...nameSpace, ...objName });
};

const FormattedMessage: React.FC<FormattedMessageProps> = (props) => {
  const { t, objName = {}, tReady, ...restProps } = props;

  const mySafeHTML = DOMPurify.sanitize(String(getTranslation(props.id, t, props.i18n, objName)));

  return (
    <span
      data-sdet={props?.id}
      {...restProps}
      dangerouslySetInnerHTML={{
        __html: mySafeHTML.replace(/href/g, "target='_blank' href"),
      }}
    />
  );
};

export const useTranslation = (id: string, sanitizeOptions?: any) => {
  const { t, i18n } = i18useTranslation();
  return DOMPurify.sanitize(getTranslation(id, t, i18n, sanitizeOptions));
};

export default withTranslation()(FormattedMessage);
